module.exports = __webpack_public_path__ + "img/sorry.ac55d1ac.png";